export type DownloadFileData = Blob | string;

export interface DownloadFileOptions {
  data: DownloadFileData;
  fileName: string;
  mimeType?: string;
}

export const downloadFile = ({
  data,
  fileName,
  mimeType = 'application/pdf',
}: DownloadFileOptions) => {
  const blob =
    data instanceof Blob ? data : new Blob([data], { type: mimeType });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
